export default "__VITE_ASSET__BvgAs3em__"